define('template/expandable',['underscore'], function(_){
    'use strict';
    
    return _.template('\
<div class="tilewall-expandable" data-abandon="false">\n\
<div class="expandable-holder trigger-html">\n\
<%= html %>\n\
</div>\n\
</div>\n\
');
});
